import { Routes, Route, BrowserRouter } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

import { LoginScreen } from '../pages/login/LoginScreen';
import DashboardContent from '../uiDashboard/DashboardContent';
import { AuthContext } from '../auth/authContext';
import { useEffect, useReducer } from 'react';
import { authReducer } from '../auth/authReducer';
import { ClientScreen } from '../pages/clientScreen/ClientScreen';
import { types } from '../types/types';
import { urlLogin } from '../helpers';
import { PrintPDFCertification } from '../pages/bill/PrintPDFCertification'
import { PrintPDF } from '../pages/bill/PrintPDF';


export const AppRouter = () => {

  const [user, dispatch] = useReducer(authReducer, {});
  useEffect(() => {
    init(dispatch)
  }, [])
console.log(user)
  return (
    <BrowserRouter>
      <AuthContext.Provider value={{ user, dispatch }}>

        {user.comprobation
          ?
          <Routes>
            <Route path='/login' element={!user?.logged ? <LoginScreen /> : <ClientScreen />}></Route>

            <Route path='/printCertification' element={!user?.logged ? <LoginScreen /> : <PrintPDFCertification />}></Route>

            <Route path='/printEstimate' element={!user?.logged ? <LoginScreen /> : <PrintPDF />}></Route>

            <Route path='/*' element={user?.logged ? <DashboardContent /> : <LoginScreen />}></Route>
          </Routes>
          : <CircularProgress/>
      }

      </AuthContext.Provider>
    </BrowserRouter>
  )
}

const init = (dispatch) => {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || ''
  if (token) {
    fetch(urlLogin, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(r => r.json())
      .then(d => {
        if (!d.error.status) {
          dispatch({
            type: types.login,
            payload: { email: d.data.email, logged: true, updatePass: d.data.updatePass, rol: d.data.rol }
          })
        }
      })
  } else {
    dispatch({type: types.logout})
  }
}